import generateFloat from '../generateFloat'

export type CalculateDiceBetResultOptions = {
  serverSeed: string
  clientSeed: string
  nonce: number
}

export default function calculateDiceBetResult(
  options: CalculateDiceBetResultOptions
) {
  const { serverSeed, clientSeed, nonce } = options

  const float = generateFloat({ serverSeed, clientSeed, nonce })

  const result = Math.floor(float * 10001) / 100

  return result
}
